(function () {

    "use strict";

    function officeServerService($http, $q) {

        var self = this;

        self.documentary = {
            public: openOfficePublicDocumentary,
            private: openOfficePrivateDocumentary
        };

        self.workplace = {
            public: openOfficePublicWorkplace,
            private: openOfficePrivateWorkplace
        };

        self.drive = {
            public: openOfficePublicDrive,
            private: openOfficePrivateDrive
        };

        self.isOfficerServer = {
            public: isOfficeServerPublic,
            private: isOfficeServerPrivate
        };

        function isOfficeServerPublic() {

            var url = '/public/office/server/hybrid';
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }

        function isOfficeServerPrivate()
        {
            var url = '/api/office/server/hybrid';
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }
        
        function openOfficePublicWorkplace(idbox, iddocument, token, action, idUrl, hash, password) {

            if (token.length === 0) {
                token = 'empty_token';
            }
            var parametros = idbox + '/' + iddocument + '/' + token + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/server/link/' + parametros + securityParams;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }

        function openOfficePrivateWorkplace(idbox, iddocument, token, action) {
            var parametros = idbox + '/' + iddocument + '/' + token + '/' + action;
            var url = '/api/office/server/link/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }

        function openOfficePublicDrive(idProvider, idDrive, idFile, token, action, idUrl, hash, password) {

            if (token.length === 0) {
                token = 'empty_token';
            }

            var parametros = idProvider + '/' + idDrive + '/' + idFile + '/' + token + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/server/link/drive/' + parametros + securityParams;

            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }

        function openOfficePrivateDrive(idProvider, idDrive, idFile, token, action) {
            var parametros = idProvider + '/' + idDrive + '/' + idFile + '/' + token + '/' + action;
            var url = '/api/office/server/link/drive/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }

        function openOfficePublicDocumentary(idfilecontainer, idfileitem, token, action, idUrl, hash, password) {

            if (token.length === 0) {
                token = 'empty_token';
            }
            var parametros = idfilecontainer + '/' + idfileitem + '/' + token + '/' + action;
            var securityParams = '/' + idUrl + '/' + hash + '/' + password;
            var url = '/public/office/server/link/documentary/' + parametros + securityParams;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    console.log(response);
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }

        function openOfficePrivateDocumentary(idfilecontainer, idfileitem, token, action) {
            var parametros = idfilecontainer + '/' + idfileitem + '/' + token + '/' + action;
            var url = '/api/office/server/link/documentary/' + parametros;
            return $q(function (resolve, reject) {
                $http({
                    method: 'GET',
                    url: url,
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function (response) {
                    resolve(response.data);
                })
                .catch(function (error) {
                    console.error(error);
                    reject();
                });
            });
        }
    }

    officeServerService.$inject = ["$http", "$q"];

    angular.module("solpheo").service("solpheo.officeServerService", officeServerService);

})();